import * as Constants from '../Constants'

export function setToken(token) {
  localStorage.setItem(Constants.TOKEN_STORAGE, token)
}

export function getToken() {
  return localStorage.getItem(Constants.TOKEN_STORAGE)
}

export function removeToken() {
  localStorage.removeItem(Constants.TOKEN_STORAGE)
}

export function setIntroShown() {
  localStorage.setItem(Constants.INTRO_SHOWN, true)
}

export function getIntroShown() {
  return localStorage.getItem(Constants.INTRO_SHOWN)
}



// WEBPACK FOOTER //
// ./src/helpers/Storages/index.js